// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';
import {ALL_COUNTRIES_KEY} from '../constants';

export const criteriaKeys = {
    CITY: 'city',
    COUNTRY_CODE: 'countryCode',
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    POSTAL_CODE: 'postalCode',
    RESET_KEY: 'resetKey',
    SELECTED_COUNTRY: 'selectedCountry',
    SELECTED_STATE: 'selectedState',
    USER_NAME: 'userName'
};

export const Criteria = t.struct({
    city: t.String,
    countryCode: t.String,
    email: t.String,
    firstName: t.String,
    lastName: t.String,
    postalCode: t.String,
    resetKey: t.Number,
    selectedCountry: t.String,
    selectedState: t.String,
    userName: t.String
}, {
    defaultProps: {
        city: '',
        countryCode: '',
        email: '',
        firstName: '',
        lastName: '',
        postalCode: '',
        resetKey: 0,
        selectedCountry: ALL_COUNTRIES_KEY,
        selectedState: '',
        userName: ''
    },
    name: 'DigitalUserSearchCriteria',
    strict: true
});
